<div class="description">
  <h2 class="h1 heading">
    <span class="pre-heading">{{
      "hhPlatform.home.eva.basedOn" | translate
    }}</span>
    Medicus
  </h2>
  <p class="text">{{ "hhPlatform.home.eva.text" | translate }}</p>
  <a
    class="learn-more"
    href="https://eva.design?utm_campaign=eva_design%20-%20home%20-%20nebular%20landing&utm_source=nebular&utm_medium=referral&utm_content=learn_more_button"
    nbButton
    size="giant"
    >{{ "hhPlatform.home.eva.learnMore" | translate}}</a
  >
</div>
<div class="images">
  <img
    class="theme-colors"
    src="assets/img/theme-colors.png"
    srcset="assets/img/theme-colors.png, assets/img/theme-colors-2x.png 2x"
    alt="Theme colors"
  />
  <img
    class="components"
    src="assets/img/components-preview.png"
    srcset="
      assets/img/components-preview.png,
      assets/img/components-preview-2x.png 2x
    "
    alt="Components preview"
  />
</div>
